<template>
	<vx-card class="packs-crear" title="Registrar código para descuento">

		<vs-button
            class="py-1 px-3 d-flex align-items-center"
            color="danger"
            type="filled"
            @click="$router.push('/codigos-descuento')"
            >
            <feather-icon
                icon="ArrowLeftCircleIcon"
                svgClasses="stroke-current"
                class="mr-2"
              />
            Regresar
            </vs-button
        >
		
		<section class="mt-5">
			<div class="vx-row">
				<div class="vx-col sm:w-3/4 w-full mb-2">
					<div class="vx-row">

		    			<div class="vx-col w-full mb-5">
			                <vs-input
			                  class="w-full"
			                  label-placeholder="Código"
			                  v-model="codigo"
			                />
			            </div>


			            <div class="vx-col sm:w-1/2 mb-5">
			                <label for="fechaInicio">Fecha inicial</label>

			                <datepicker id="fechaInicio" v-model="fechaInicio" :language="langDatePicker"></datepicker>
			            </div>

			            <div class="vx-col sm:w-1/2 w-full mb-5">
		                    <label for="fechaVigente">Fecha final</label>

			                <datepicker id="fechaVigente" v-model="fechaVigente" :language="langDatePicker"></datepicker>
		                </div>

		                <div class="vx-col sm:w-1/2 mb-5">
			                <vs-input
			                  type="number"
			                  min="0"
			                  step="1"
			                  class="w-full"
			                  label-placeholder="Unidades"
			                  v-model="unidades"
			                />
			            </div>

			            <div class="vx-col sm:w-1/2 w-full mb-5">
		                    <vs-input
			                  type="number"
			                  min="0"
			                  class="w-full"
			                  label-placeholder="Porcentaje a descontar"
			                  v-model="montoDescuento"
			                />
		                </div>
			        </div>
			    </div>
    		</div>
		</section>

		<section>
			<div class="d-flex justify-content-end">
				<vs-button
		            class="custom-btn d-flex justify-content-center align-items-center mr-3"
		            color="success"
		            :disabled="creando || !validate"
		            @click="crear()"
		            >
		            {{ creando ? 'Creando...' : 'Crear' }}

		            <feather-icon
			            icon="ArrowRightIcon"
			            svgClasses="stroke-current"
			            @click="crear()"
			         />
		            </vs-button
		        >
			</div>
		</section>
	</vx-card>
</template>

<script>
	import createCupones from '@/apollo/mutations/codigos-descuentos/createCupones.gql'

	import Datepicker from 'vuejs-datepicker';
	import {en, es} from 'vuejs-datepicker/dist/locale'

	export default {
		data() {
			return {
				codigo: null,
				fechaInicio: new Date(),
				fechaVigente: new Date(),
				multiple: false,
				cargaInicial: true,
				cargandoProductos: false,
				productos: [],
				itemsSeleccionados: [],
				unidades: null,
				montoDescuento: null,
				datePickerFormat: 'MMMM yyyy',
				langDatePicker: es,
				creando: false
			}
		},
		mounted() {
		},
		components: {
			Datepicker
		},
		methods: {
		    crear() {
		    	this.creando = true

		    	let { codigo, fechaInicio, fechaVigente, unidades, montoDescuento } = this

		    	let input = {
		    		estado: 1,
    				codigo,
    				fechaInicio: this.$dayjs(fechaInicio).format('YYYY-MM-DD'),
    				fechaVigente: this.$dayjs(fechaVigente).format('YYYY-MM-DD'),
    				unidades: parseInt(unidades),
    				montoDescuento: parseFloat(montoDescuento)
    			}

		    	this.$apollo.mutate({
		    		mutation: createCupones,
		    		variables: {
		    			input
		    		}
		    	})
		    	.then(() => {
		    		this.$router.push("/codigos-descuento");

			          this.creando = false;

			          this.$vs.notify({
			            title: "Código agregado",
			            color: "success",
			            position: "top-right",
			          });
		    	})
		    }
		},
		computed: {
			validate() {
				let status = false

				let { codigo, fechaInicio, fechaVigente, unidades, montoDescuento } = this

				if(codigo && fechaInicio && fechaVigente && unidades && montoDescuento) {
					status = true
				}

				return status
			}
		}
	}
</script>

<style lang="scss">
.packs-crear {
	.v-select.vs--single.vs--searchable {
		width: 300px;
	}

	.table-image {
		width: 30px;
		height: 30px;
	}

	.vs-component.con-vs-checkbox.vs-checkbox-primary.vs-checkbox-default {
		width: 50px;
	}
}

.small {
	font-size: .9em;
}
</style>